import { getMode } from '@whistler-ui/k2/constants/settings';

// Define a type for log levels
type LogLevel = 'log' | 'info' | 'debug' | 'table';

// Logger function
export const logger = (message: any, level: LogLevel = 'log'): void => {
  const modes = getMode();

  if (modes.IS_DEV) {
    switch (level) {
      case 'log': {
        console.log(
          '%c[LOG]',
          'color: blue; background-color: lightblue;',
          message,
        );
        break;
      }
      case 'debug': {
        console.debug(
          '%c[DEBUG]',
          'color: green; background-color: lightgreen;',
          message,
        );
        break;
      }
      case 'info': {
        console.info(
          '%c[INFO]',
          'color: purple; background-color: #f3e5f5;',
          message,
        );
        break;
      }
      case 'table': {
        console.log('%c[TABLE]', 'color: teal; background-color: #e0f7fa;');
        console.table(message);
        break;
      }
      default: {
        console.log(
          '%c[LOG]',
          'color: blue; background-color: lightblue;',
          message,
        );
      }
    }
  }

  return null;
};

/**
 * Generates an array of evenly spaced tick values for a chart axis.
 *
 * @example
 * calculateTicks(100);
 * // Returns [0, 20, 40, 60, 80, 100]
 *
 * @example
 * calculateTicks(90, 4);
 * // Returns [0, 30, 60, 90]
 */
export const calculateTicks = (maxValue: number, numberOfTicks = 6) => {
  if (maxValue === 0) return [0];

  const stepSize = maxValue / (numberOfTicks - 1);

  const ticks = Array.from({ length: numberOfTicks }, (_, i) =>
    Math.round(i * stepSize),
  );

  return [...new Set(ticks)];
};
